"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { hasAbAssignment, sendAbEvent } from "@/lib/ab-client";

function AnalyticsProviderInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (pathname.startsWith("/admin")) return;

    // Homepage A/B funnel: reaching the contact page counts for visitors who
    // were assigned a variant (the server checks they actually saw it).
    if (pathname === "/contact" && hasAbAssignment()) sendAbEvent("contact_visit");

    const params = Object.fromEntries(searchParams.entries());

    fetch("/api/analytics/pageview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path: pathname,
        utm_source: params.utm_source ?? "",
        utm_medium: params.utm_medium ?? "",
        utm_campaign: params.utm_campaign ?? "",
        utm_content: params.utm_content ?? "",
        utm_term: params.utm_term ?? "",
        referrer: typeof document !== "undefined" ? document.referrer : "",
      }),
    });
  }, [pathname, searchParams]);

  return null;
}

export default function AnalyticsProvider() {
  return (
    <Suspense fallback={null}>
      <AnalyticsProviderInner />
    </Suspense>
  );
}
